import { MetricQuery } from "../metrics.types";
import { formatMetricLabel } from "../metrics.helpers";

export function getMetricName(metricQuery: MetricQuery): string {
    const resolution =
        metricQuery.periodResolution === "m"
            ? "Monthly"
            : metricQuery.periodResolution === "q"
              ? "Quarterly"
              : "Annual";
    return resolution + " " + formatMetricLabel(metricQuery.metric);
}
